<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="`Update Language: ${language.name}`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form id="language-update-popup" @submit.prevent="handleSubmit(handleUpdateLanguage)" autocomplete="off">

        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-full md:mb-0">
            <small class="label">Name</small>
            <vs-input v-model="language.name" name="name" disabled class="w-full" label="" val-icon-danger="icon-x"
                      val-icon-pack="feather"/>

          </div>
        </div>

        <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-full md:mb-0">
            <small class="label">Code</small>
            <vs-input v-model="language.code" name="code" disabled class="w-full" label="" val-icon-danger="icon-x"
                      val-icon-pack="feather"/>
          </div>
        </div>

        <div class="mb-3 vx-row" v-if="language.code !== 'en'">
          <div class="w-full vx-col md:w-full md:mb-0">
            <ValidationProvider vid="status" name="status" rules="required" v-slot="{ errors }">
              <small class="label">Language Status</small>
              <v-select name="status" :closeOnSelect="true" label="name" :reduce="option => option.value"
                        v-model="form.status"
                        :disabled="language.code === 'en'"
                        :selectable="(option) => option.value !== 'primary'"
                        :options="status_types"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>

        <div class="flex flex-wrap items-center justify-end mt-8" v-if="language.code !== 'en'">
          <vs-button v-can="'edit-tenant-language'" button="submit" class="mt-2 ml-auto">
            Save Changes
          </vs-button>
          <vs-button @click="clearForm" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
        </div>
      </form>
    </ValidationObserver>

  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const LocalizationRepository = RepositoryFactory.get('localization')

export default {
  name: "UpdateLanguage",
  data() {
    return {
      open: false,
      id: '',
      tenant_id: null,
      language: {},
      form: {
        status: '',
      },
      status_types: [{name: 'Secondary', value: 'secondary'}, {name: 'Other', value: 'other'}]
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods: {
    async openPopup(id) {
      this.id = id
      this.tenant_id = this.$route.params.id
      await this.fetchLanguage()
      this.open = true;
    },
    async fetchLanguage() {
      await this.$vs.loading()
      const {data} = await LocalizationRepository.fetchLanguage(this.tenant_id, this.id)
      this.language = data.data
      this.form = {
        status: data.data.status,
      }
      this.$vs.loading.close()
    },
    async handleUpdateLanguage() {
      const vue = this;
      await this.$vs.loading()
      try {
        await LocalizationRepository.updateLanguage(this.tenant_id, this.id, this.form)
        this.showSuccessMessage('Language Updated Successfully');
        await vue.$parent.refreshData();
        this.open = false
      } catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    clearForm() {
      this.form = {}
    }
  }

}
</script>

<style scoped>
</style>
